import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { CLINIC_STATUS_ENUM, CLINIC_STATUS_OPTIONS } from '../../appContants';
import ClinicLocationsForm from './ClinicLocationsForm';
import { useClinicStatusUpdate } from '../../hooks/clinic/useClinicStatusUpdate';

const ClinicDetails = ({ data, onReload }) => {
  const navigate = useNavigate();
  const { loading, status, updateClinicStatus } = useClinicStatusUpdate();
  const [form] = Form.useForm();

  const handleApprove = async () => {
    // Call api to approve the clinic
    await updateClinicStatus(CLINIC_STATUS_ENUM.APPROVED);
    onReload?.();
  };
  const handleDisapprove = async () => {
    // Call api to disapprove the clinic
    await updateClinicStatus(CLINIC_STATUS_ENUM.DISAPPROVE);
    onReload?.();
  };
  const handleDisable = async () => {
    // Call api to disable the clinic
    await updateClinicStatus(CLINIC_STATUS_ENUM.DISABLE);
    onReload?.();
  };
  const handleEnable = async () => {
    // Call api to enable the clinic
    await updateClinicStatus(CLINIC_STATUS_ENUM.ENABLE);
    onReload?.();
  };

  return (
    <Form
      form={form}
      initialValues={data}
      onFinish={(values) => console.log('values : ', values)}
      layout="vertical"
    >
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Title" name="title" required>
            <Input disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Address" name="address" required>
            <Input disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Mobile" name="contactNumber" required>
            <Input disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Status" name="status" required>
            <Select
              disabled
              options={CLINIC_STATUS_OPTIONS}
              className="w-100"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name={'clinicLocations'}>
        <ClinicLocationsForm />
      </Form.Item>
      <Form.Item className="mt-3">
        <Space>
          {data?.status === CLINIC_STATUS_ENUM.CREATED ||
          data?.status === CLINIC_STATUS_ENUM.DISAPPROVE ? (
            <Button
              key="approve"
              type="primary"
              htmlType="submit"
              loading={status === CLINIC_STATUS_ENUM.APPROVED}
              onClick={handleApprove}
            >
              Approved
            </Button>
          ) : null}
          {data?.status === CLINIC_STATUS_ENUM.CREATED ? (
            <Button
              key="disapprove"
              type="primary"
              htmlType="submit"
              loading={status === CLINIC_STATUS_ENUM.DISAPPROVE}
              onClick={handleDisapprove}
            >
              Disapproved
            </Button>
          ) : null}
          {data?.status === CLINIC_STATUS_ENUM.APPROVED ? (
            <Button
              key="disable"
              type="primary"
              htmlType="button"
              loading={status === CLINIC_STATUS_ENUM.DISABLE}
              onClick={handleDisable}
            >
              Disabled
            </Button>
          ) : null}
          {data?.status === CLINIC_STATUS_ENUM.DISABLE ? (
            <Button
              key="enable"
              type="primary"
              htmlType="button"
              loading={status === CLINIC_STATUS_ENUM.ENABLE}
              onClick={handleEnable}
            >
              Enabled
            </Button>
          ) : null}
          <Button
            htmlType="button"
            disabled={loading}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
ClinicDetails.propTypes = {
  data: PropTypes.object,
  onReload: PropTypes.func,
};
export default ClinicDetails;
